export const Heap = {
	identify: (id: string) => {
		window.heap.identify(id);
	},

	track: (eventName: string, eventProperties: Record<string, any>) => {
		window.heap.track(eventName, eventProperties);
	},

	addUserProperties: (userProperties: Record<string, any>) => {
		window.heap.addUserProperties(userProperties);
	},

	addEventProperties: (
		eventName: string,
		eventProperties: Record<string, any>
	) => {
		window.heap.addEventProperties({
			[eventName]: true,
			...eventProperties,
		});
	},

	clearEventProperties: () => {
		window.heap.clearEventProperties();
	},
};
